

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>





<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>

<br><br>


<div class="row"  data-aos="zoom-in" data-aos-delay="300">
  <div class="col-md-6 text-center ">
    <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/VendorOnboarding.png">
</div>
    <div  class="col-md-6">
      <br>
      <br>
      <br>
      <br>

        <h1>
            <span class="topic">Due Diligence Solutions for Vendor Onboarding </span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;End-to-End Digitization of the onboarding journey for your vendors </h5>
    </div>

   
</div>
<br>
<br>
<br>

<div class="row"  data-aos="fade-up" data-aos-delay="300">
    <div class="col">
        <h1 style="color: #6ab187;text-align: center;">Overcoming the Challenges with <br>Vendor Onboarding </h1>
        <br>
        <p style="text-align: center;">Business verification and due diligence to partner with the right vendors</p>


           <br><br>
<div  class="row p-2 ">

    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
        <img style="width: 70px;height: 65px;background-color: #eff8ff;" src="assets/homee.jpg">
       <br><br><br>
        <h5>No More Working in Silos</h5>
        <p style="align-items: center;">Do away with the herculean task of individually managing multiple vendors using Excel spreadsheets. Get all your vendors’ data on a single platform.</p>
    </div>
  
    <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
          <br>
          <img style="width: 70px;height: 60px;" src="assets/vendor.png">
         <br><br><br>
          <h5>Single View of All Your Vendors </h5>
          <p style="align-items: center;">Track the progress of all your vendors’ onboarding journey on a single platform. Allowing your team to forecast and give actionable insights</p>
      </div>
     
       
    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/regulacompl.jpg">
       <br><br><br>
        <h5>Ensure Regulatory Compliance</h5>
        <p style="align-items: center;">Ensure all your vendors comply with the industry and government-mandated regulatory requirements with a compliant vendor onboarding solution</p>
    </div>

      <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
     
        <br>
        <img style="width: 70px;height: 70px;" src="assets/remoteonboard.png">
       <br><br><br>
        <h5>Remote Onboarding</h5>
        <p style="align-items: center;">Onboard your vendors faster with paperless onboarding. Digital verification of vendor identity documents for a seamless and paperless experience.<p>
    </div>
  </div>
    </div>
</div> 


<br><br><br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
        <h5 style="text-align: center;">How to do Vendor Due Diligence?</h5>
        <h2 style="color: #6ab187;text-align: center;">Vendor Onboarding and Due Dilligence Process</h2>
        <br><br><br><br>
        <img style="width: 5%;height: 27%;margin-left: 15%;" src="assets/initial.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        <img style="width: 5%;height: 27%;margin-left: 5%;" src="assets/datacollect.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        <img style="width: 5%;height: 27%;margin-left: 5%;" src="assets/due.jpg">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        <img style="width: 5%;height: 27%;margin-left: 5%;" src="assets/approval.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

    </div>

</div>

<div class="row" data-aos="fade-up" data-aos-delay="300">
    <div class="col">
        <br><br><br><br><br>
        <img style="width: 5%;height: 39%;margin-left: 28%;" src="assets/contract.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">
        
        <img style="width: 5%;height: 33%;margin-left: 30px;" src="assets/erpintegrate.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        
        <img style="width: 5%;height: 33%;margin-left: 30px;" src="assets/monitoring.png">
    </div>
</div>


<!--  -->
<br><br>
<br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Facheck’s Vendor Due Diligence Solution </h3>
        <h2 style="text-align: center;color: #6ab187;">Transforming Vendor Onboarding  Experience </h2>
     <p style="text-align: center;">Vendor Authentication Solution for Every Step of the Vendor Onboarding and Verification Process</p>
    </div>
</div>

<br><br><br><br>
<!--  -->
<div class="row p-2" data-aos="fade-up" data-aos-delay="300"   >
  <div class="col-md-6">
      <br>
      <img style="width: 39px;height: 39px" src="assets/initiation.png">
      <span style="color: #6ab187;">Initiation</span><br>
      <h3 style="text-align: start;color: #6ab187;">Initiate Vendor Registration via Multiple Channels</h3>
      <p >Initiate the vendor registration process by sending the invitation link through email, SMS, or WhatsApp. Onboard the vendor faster by bulk uploading their information or choosing to initiate the process for a single vendor.</p>
  </div>

  <div class="col-md-6 text-center  ">
      <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/multiplevendor.png">
  </div>
  </div>


   <!--  -->
     
   <div class="row p-2" data-aos="fade-up" data-aos-delay="300"  >
    
       <div class="col-md-6 text-center">
           <img style="width: 80%;height: 100%;margin-left: 20px;" src="assets/datacollection.jpg">
       </div>
   
       <div class="col-md-6">
           <img style="width: 42px;height: 45px;" src="assets/automation.png">
           <span style="color: #6ab187;height: 20%;">Automation</span>
           <h3 style="text-align: start;color: #6ab187;">Configurable Automated Workflows for Data Collection</h3>
           <p >Do away with manual data collection. A configurable platform to set up workflows to collect verification documents such as PoI, PoA, GSTIN number, DIN, CIN, Shop & Establishment License, Balance Sheet or any other additional documents to accelerate the vendor onboarding</p>
       </div>
   </div>



 
   <!--  -->
   <div class="row p-2" data-aos="fade-up" data-aos-delay="300"   >
     <div class="col-md-6">
         <br>
         <img style="width: 39px;height: 39px" src="assets/riskmitigatee.png">
         <span style="color: #6ab187;">Risk Mitigation</span><br>
         <h3 style="text-align: start;color: #6ab187;">Due Diligence for Risk Management</h3>
         <p >Leverage the proprietary technology to conduct faster vendor due diligence . Identify the associated risk or issues with your vendors and take corrective actions to safeguard your brand reputation and mitigate the risk.</p>
     </div>
   
     <div class="col-md-6 text-center">
         <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/riskmanagement.jpg">
     </div>
     </div>



     <div class="row p-2"  data-aos="fade-up" data-aos-delay="300" >
      
         <div class="col-md-6 text-center ">
             <img style="width: 70%;height: 90%;margin-left: 20px;margin-top: 30px;" src="assets/approval.jpg">
         </div>
     
         <div class="col-md-6">
             <img style="width: 42px;height: 45px" src="assets/approve.png">
             <span style="color: #6ab187;height: 20%;margin-top: 30px;">Approval Management</span>
             <h3 style="text-align: start;color: #6ab187;">Streamline Approvals Across the Onboarding Process
            </h3>
             <p >Process initiator to the reviewer to approver – set up configurable workflows to nudge the stakeholders to complete their assigned duties and responsibilities to move the case to the next step. Accelerate the approval process by automating your approval journeys.</p>
         </div>
     </div>
  


     
     <!--  -->
     <div class="row p-2"  data-aos="fade-up" data-aos-delay="300" >
       <div class="col-md-6">
           <br>
           <img style="width: 39px;height: 42px;" src="assets/contractsign.jpg">
           <span style="color: #6ab187;">Digital Contracting</span><br>
           <h3 style="text-align: start;color: #6ab187;">Digital Signing for Faster Contract Management</h3>
           <p >Close vendor contracts faster with an array of digital signature options. The e-sign tool allows your vendors, etc to upload their e-signature to sign the onboarding contract or e-sign the stamp papers. Collaborate with different stakeholders to co-sign the contract and fast-track the onboarding process.</p>
       </div>
     
       <div class="col-md-6  text-center">
           <img style="width: 80%;height: 90%;margin-top: 20px;" src="assets/digitalcontract.png">
       </div>
       </div>
  



      
       <div class="row p-2" data-aos="fade-up" data-aos-delay="300"  >
        
           <div class="col-md-6 text-center  ">
               <img style="width: 80%;height: 70%;margin-left: 20px;margin-top: 20px;" src="assets/erp.png">
           </div>
       
           <div class="col-md-6">
               <img style="width: 42px" src="assets/seamless connect.png">
               <span style="color: #6ab187;height: 20%;margin-top: 30px;"> Seamless Connectivity</span>
               <h3 style="text-align: start;color: #6ab187;">Easy Integration with Enterprise-grade ERPs
              </h3>
               <p >Vendor authentication is made easy with seamless integrations. Integrate our advanced vendor onboarding solution with your ERP platforms such as SAP, Tally, Oracle, Microsoft, and others to allow two-way communication to fetch vendor information from various government databases like UIDAI, NSDL, MCA, and Income tax e-portal.</p>
           </div>
       </div>
    

       <!--  -->
       <div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
         <div class="col-md-6">
             <br>
             <img style="width: 42px;height: 45px" src="assets/risklog.png">
             <span style="color: #6ab187;">Risk Assessment</span><br>
             <h3 style="text-align: start;color: #6ab187;">Proactive Risk Watch to Monitor Early Warning Signs</h3>
             <p >Safeguard your business reputation by conducting regular vendor checks to identify any probable risks. Conduct regular checks via public domain or subscribed databases to adhere to required compliances like EPFO compliance, GSTIN compliance, Financial evaluation and others.</p>
         </div>
       
         <div class="col-md-6 text-center ">
             <img style="width: 80%;height: 90%;margin-top: 20px;" src="assets/safeguard.png">
         </div>
         </div>



  
 <div class="row" data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">Facheck Vendor Screening and Onboarding Solution </h2>
    </div>
    </div>
    <br>
  
     
  <div  class="row p-2"  >
  
    <div style="background-color: #eff8ff;"  data-aos="fade-up" data-aos-delay="300" class="col-md-3">
        <br>
        <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/signout.png">
       <br><br><br>
        <h5>Single Sign-on</h5>
        <p style="align-items: center;">For Secure User Authentication and Compliance</p>
    </div>
  
    <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
          <br>
          <img style="width: 70px;height: 80px;" src="assets/multiple.png">
         <br><br>
          <h5>Multi-Channel Engagement </h5>
          <p style="align-items: center;">To Streamline Communication</p>
      </div>
     
      <div  style="background-color: #eff8ff;"  data-aos="fade-up" data-aos-delay="300" class="col-md-3">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/report&dashboard.png">
       <br><br><br>
        <h5>Interactive Dashboards & Custom Reports </h5>
        <p style="align-items: center;">Real-time tracking of case status<p>
    </div>


    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
        <br>
        <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/multilingual.png">
       <br><br><br>
        <h5>Multilingual Forms</h5>
        <p style="align-items: center;">For expanding the reach and improving conversions</p>
    </div>
    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
      <br>
      <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/vendorrepo.png">
     <br><br><br>
      <h5>Vendor Respitory</h5>
      <p style="align-items: center;">To create a list of all the vendors for future use</p>
  </div>

  <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
        <br>
        <img style="width: 70px;height: 80px;" src="assets/propriotary.png">
       <br><br>
        <h5>1Bn+ Proprietary Database</h5>
        <p style="align-items: center;">For quicker verification and turnaround time (TAT)</p>
    </div>
   
    <div  style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
   
      <br>
      <img style="width: 60px;height: 60px;" src="assets/crmerp.png">
     <br><br><br>
      <h5>Integration with ERP/CRMs</h5>
      <p style="align-items: center;">Two-way communication across multiple channels<p>
  </div>


  <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-3">
      <br>
      <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/customizedalert.jpg">
     <br><br><br>
      <h5>Customized Alerts and Notifications</h5>
      <p style="align-items: center;">To keep track of case status and notify stakeholders</p>
  </div>



  </div>
  
  
 

  
  
   



<!--  -->
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
      <br><br><br>
        <h3 style="text-align: center;color: #6ab187;">20+ Vendor Screening and Onboarding Checks</h3><br>
        <p style="text-align: center;">Built for Success at Every Step of the Onboarding Journey</p>
    </div>

</div>
<br><br>


<!--  -->
<div  class="row p-2 text-center">
  <div class="col-md-3 mt-2" >
      <div  class="card"  style="height: 200px;"     >
          <div class="card-body">
              <img style="width: 34%;height:30%" src="assets/udyogaadhaar.jpg">
              <br><br>
            <h5 class="card-title">Udyog Aadhaar</h5>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2" >
    <div class="card"  style="height: 200px;"     >
        <div class="card-body">
            <img style="width: 34%;height:30%" src="assets/bankaccount.png">
            <br><br>
          <h5 class="card-title">Bank Account</h5>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2" >
  <div class="card"  style="height: 200px;"     >
      <div  class="card-body">

          <img style="width: 30%;height:30%" src="assets/directorcheck.jpg">
          <br><br>
        <h5 class="card-title">Defaulting Directors Check</h5>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 200px;"     >
    <div class="card-body">
        <img style="width: 34%;height:30%"  src="assets/tincheck.png">
        <br><br>
      <h5 class="card-title">TIN Check</h5>

    </div>            
  </div>
</div>

<div class="col-md-3 mt-2" >
  <div  class="card"  style="height: 200px;"     >
      <div class="card-body">
          <img style="width: 34%;height:30%" src="assets/businesswork.png">
          <br><br>
        <h5 class="card-title">Business address</h5>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 200px;"     >
    <div class="card-body">
        <img style="width: 34%;height:30%" src="assets/GSTIN.jpg">
        <br><br>
      <h5 class="card-title">GSTIN verify</h5>
    </div>            
  </div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 200px;"     >
  <div  class="card-body">

      <img style="width: 30%;height:30%" src="assets/panchecks.png">
      <br><br>
    <h5 class="card-title">PAN Card</h5>
  </div>            
</div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 200px;"     >
<div class="card-body">
    <img style="width: 34%;height:30%"  src="assets/dinverify.jpg">
    <br><br>
  <h5 class="card-title">DIN verify</h5>
</div>            
</div>
</div>
</div>





